export const commonStyles = {
  page: { pb: 15 },
  container: { pt: { xs: 8, sm: 10, md: 15 }, pb: { xs: 1, sm: 3, md: 10 }, height: "100%", width: { xs: "90%", sm: "80%", md: "80%" } }
};